<!DOCTYPE html>
<html>
<head>
<title>BusinessHub - Advanced FP&A Analytics Platform</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
<link rel="stylesheet" href="https://www.w3schools.com/lib/w3-theme-indigo.css">
</head>
<body id="myPage">

<!-- Navigation Bar -->
<div class="w3-top">
  <div class="w3-bar w3-theme-d2 w3-left-align w3-large">
    <a class="w3-bar-item w3-button w3-padding-large w3-hide-medium w3-hide-large w3-right" href="javascript:void(0);" (click)="toggleNavigation()" title="Toggle Navigation Menu"><i class="fa fa-bars"></i></a>
    <a href="#" class="w3-bar-item w3-button w3-padding-large w3-theme-d4"><i class="fa fa-home w3-margin-right"></i>BusinessHub</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white" (click)="scrollToSection('features')" title="Features"><i class="fa fa-th w3-margin-right"></i>Features</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white" (click)="scrollToSection('benefits')" title="Benefits"><i class="fa fa-star w3-margin-right"></i>Benefits</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white" (click)="scrollToSection('pricing')" title="Pricing"><i class="fa fa-usd w3-margin-right"></i>Pricing</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white" (click)="scrollToSection('contact')" title="Contact"><i class="fa fa-envelope w3-margin-right"></i>Contact</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white w3-right" (click)="scrollToSection('demo')" title="Request Demo"><i class="fa fa-play w3-margin-right"></i>Request Demo</a>
    <a href="javascript:void(0);" class="w3-bar-item w3-button w3-hide-small w3-padding-large w3-hover-white w3-right" (click)="login()" title="Login"><i class="fa fa-sign-in w3-margin-right"></i>Login</a>
  </div>
</div>

<!-- Navbar on small screens -->
<div id="navDemo" class="w3-bar-block w3-theme-d2 w3-hide w3-hide-large w3-hide-medium w3-large">
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="scrollToSection('features')">Features</a>
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="scrollToSection('benefits')">Benefits</a>
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="scrollToSection('pricing')">Pricing</a>
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="scrollToSection('contact')">Contact</a>
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="scrollToSection('demo')">Request Demo</a>
  <a href="javascript:void(0);" class="w3-bar-item w3-button w3-padding-large" (click)="login()">Login</a>
</div>

<!-- Hero Section -->
<div class="w3-display-container w3-animate-opacity hero-section" (mousemove)="onMouseMove($event)">
  <!-- Animated background elements -->
  <div class="animated-bg">
    <svg class="ticker-line ticker-1" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path class="line-path" d="M0,80 Q20,20 40,60 T80,40 L100,20" stroke="rgba(255,255,255,0.15)" stroke-width="2" fill="none"/>
    </svg>
    <svg class="ticker-line ticker-2" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path class="line-path" d="M0,50 Q20,10 40,80 T80,30 L100,60" stroke="rgba(255,255,255,0.12)" stroke-width="2" fill="none"/>
    </svg>
    <svg class="ticker-line ticker-3" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path class="line-path" d="M0,20 Q20,70 40,30 T80,70 L100,40" stroke="rgba(255,255,255,0.1)" stroke-width="2" fill="none"/>
    </svg>
  </div>

  <!-- Mouse reactive overlay -->
  <div class="mouse-reactive-overlay" [style.left.px]="mouseX" [style.top.px]="mouseY"></div>

  <div class="w3-container w3-text-white hero-content">
    <h1 class="w3-xxxlarge w3-animate-top"><b>Transform Your Financial Planning & Analysis</b></h1>
    <h3 class="w3-large w3-margin-bottom-16 w3-animate-bottom">Unlock powerful insights from your data with our advanced FP&A platform</h3>

  </div>
</div>

<!-- Features Section -->
<div class="w3-container w3-padding-64 w3-center" id="features">
  <h2 class="w3-wide">POWERFUL FP&A CAPABILITIES</h2>
  <p class="w3-opacity"><i>Everything you need to drive better business decisions</i></p><br>

  <div class="w3-row-padding w3-center w3-margin-top">
    <div class="w3-quarter">
      <div class="w3-card w3-white w3-padding-16 w3-hover-shadow feature-card" (click)="toggleFeature('data-integration')">
        <div class="w3-container w3-padding-16">
          <i class="fa fa-database w3-margin-bottom w3-text-theme" style="font-size:64px"></i>
          <h3>Data Integration</h3>
          <p>Seamlessly connect and integrate data from multiple sources including ERP systems, databases, and spreadsheets</p>
        </div>
      </div>
    </div>
    <div class="w3-quarter">
      <div class="w3-card w3-white w3-padding-16 w3-hover-shadow feature-card" (click)="toggleFeature('advanced-analytics')">
        <div class="w3-container w3-padding-16">
          <i class="fa fa-bar-chart w3-margin-bottom w3-text-theme" style="font-size:64px"></i>
          <h3>Advanced Analytics</h3>
          <p>Powerful forecasting, scenario modeling, and predictive analytics to anticipate market trends</p>
        </div>
      </div>
    </div>
    <div class="w3-quarter">
      <div class="w3-card w3-white w3-padding-16 w3-hover-shadow feature-card" (click)="toggleFeature('real-time-dashboards')">
        <div class="w3-container w3-padding-16">
          <i class="fa fa-desktop w3-margin-bottom w3-text-theme" style="font-size:64px"></i>
          <h3>Real-time Dashboards</h3>
          <p>Interactive dashboards and KPI monitoring with real-time data updates and alerts</p>
        </div>
      </div>
    </div>
    <div class="w3-quarter">
      <div class="w3-card w3-white w3-padding-16 w3-hover-shadow feature-card" (click)="toggleFeature('collaborative-planning')">
        <div class="w3-container w3-padding-16">
          <i class="fa fa-users w3-margin-bottom w3-text-theme" style="font-size:64px"></i>
          <h3>Collaborative Planning</h3>
          <p>Enable team collaboration with role-based access, workflow automation, and approval processes</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Expandable Feature Sections -->
  <div class="feature-expansions">
    <!-- Data Integration Expansion -->
    <div class="feature-expansion" [class.expanded]="expandedFeature === 'data-integration'">
      <div class="expansion-content">
        <div class="w3-row">
          <div class="w3-col m6">
            <h3><i class="fa fa-database w3-margin-right w3-text-theme"></i>Data Integration</h3>
            <p>Connect all your data sources seamlessly with our powerful integration engine.</p>
            <ul class="w3-ul">
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>ERP System Integration (SAP, Oracle, NetSuite)</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Database Connectivity (SQL, NoSQL)</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Excel & CSV Import/Export</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>API Integration & Web Services</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Real-time Data Synchronization</li>
            </ul>
          </div>
          <div class="w3-col m6">
            <div class="feature-image">
              <i class="fa fa-plug w3-text-theme" style="font-size:120px;opacity:0.3;"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Advanced Analytics Expansion -->
    <div class="feature-expansion" [class.expanded]="expandedFeature === 'advanced-analytics'">
      <div class="expansion-content">
        <div class="w3-row">
          <div class="w3-col m6">
            <h3><i class="fa fa-bar-chart w3-margin-right w3-text-theme"></i>Advanced Analytics</h3>
            <p>Leverage AI-powered analytics to predict trends and optimize your financial planning.</p>
            <ul class="w3-ul">
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Predictive Forecasting Models</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Scenario Planning & What-if Analysis</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Machine Learning Algorithms</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Statistical Analysis Tools</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Trend Analysis & Pattern Recognition</li>
            </ul>
          </div>
          <div class="w3-col m6">
            <div class="feature-image">
              <i class="fa fa-brain w3-text-theme" style="font-size:120px;opacity:0.3;"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Real-time Dashboards Expansion -->
    <div class="feature-expansion" [class.expanded]="expandedFeature === 'real-time-dashboards'">
      <div class="expansion-content">
        <div class="w3-row">
          <div class="w3-col m6">
            <h3><i class="fa fa-desktop w3-margin-right w3-text-theme"></i>Real-time Dashboards</h3>
            <p>Monitor your KPIs and performance metrics with live, interactive dashboards.</p>
            <ul class="w3-ul">
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Customizable Dashboard Builder</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Real-time Data Updates</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Interactive Charts & Graphs</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Alert & Notification System</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Mobile-Responsive Design</li>
            </ul>
          </div>
          <div class="w3-col m6">
            <div class="feature-image">
              <i class="fa fa-tachometer w3-text-theme" style="font-size:120px;opacity:0.3;"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Collaborative Planning Expansion -->
    <div class="feature-expansion" [class.expanded]="expandedFeature === 'collaborative-planning'">
      <div class="expansion-content">
        <div class="w3-row">
          <div class="w3-col m6">
            <h3><i class="fa fa-users w3-margin-right w3-text-theme"></i>Collaborative Planning</h3>
            <p>Enable seamless teamwork with role-based access and workflow automation.</p>
            <ul class="w3-ul">
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Role-based Access Control</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Workflow Automation</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Approval & Review Processes</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Version Control & Change Tracking</li>
              <li><i class="fa fa-check w3-margin-right w3-text-theme"></i>Team Collaboration Tools</li>
            </ul>
          </div>
          <div class="w3-col m6">
            <div class="feature-image">
              <i class="fa fa-handshake-o w3-text-theme" style="font-size:120px;opacity:0.3;"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Benefits Section -->
<div class="w3-row-padding w3-padding-64 benefits-section" id="benefits">
  <div class="w3-container w3-center">
    <h2 class="w3-wide">WHY CHOOSE BUSINESSHUB</h2>
    <p class="w3-opacity"><i>Transform your financial planning and analysis</i></p>

    <div class="w3-row-padding w3-margin-top">
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-rocket w3-margin-right w3-text-theme"></i>Accelerate Decision Making</h4>
          <p>Reduce analysis time from days to hours. Our FP&A platform provides instant access to real-time data and automated reporting, enabling faster, more informed decisions that keep you ahead of the competition.</p>
        </div>
      </div>
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-chart-line w3-margin-right w3-text-theme"></i>Unlock Hidden Insights</h4>
          <p>Discover patterns and trends that traditional spreadsheets miss. Advanced analytics and AI-powered forecasting reveal opportunities for cost savings, revenue optimization, and strategic growth.</p>
        </div>
      </div>
    </div>

    <div class="w3-row-padding w3-margin-top">
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-users w3-margin-right w3-text-theme"></i>Empower Your Team</h4>
          <p>Give your analysts superpowers. Automated data processing, intuitive dashboards, and collaborative workflows free up time for strategic analysis and value-added insights that drive business impact.</p>
        </div>
      </div>
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-shield-alt w3-margin-right w3-text-theme"></i>Reduce Risk & Errors</h4>
          <p>Eliminate manual spreadsheet errors and version control issues. Centralized data, automated calculations, and audit trails ensure accuracy and compliance while reducing financial risk.</p>
        </div>
      </div>
    </div>

    <div class="w3-row-padding w3-margin-top">
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-dollar-sign w3-margin-right w3-text-theme"></i>Maximize ROI</h4>
          <p>See immediate returns on your investment. Companies using BusinessHub report faster reporting cycles, improved forecast accuracy, and significant time savings for their finance teams.</p>
        </div>
      </div>
      <div class="w3-col m6">
        <div class="benefit-card">
          <h4><i class="fa fa-lightbulb w3-margin-right w3-text-theme"></i>Future-Proof Your Business</h4>
          <p>Stay ahead of market changes with scenario planning and predictive analytics. Our platform adapts to your business needs, scaling as you grow and evolving with industry best practices.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Pricing Section -->
<div class="w3-row-padding w3-center w3-padding-64 pricing-section" id="pricing">
  <div class="w3-container">
    <h2 class="w3-wide">PRICING & PLANS</h2>
    <p class="w3-opacity"><i>Flexible solutions tailored to your organization</i></p>

    <div class="pricing-content">
      <div class="w3-row-padding w3-margin-top">
        <div class="w3-col m8 w3-center">
          <div class="pricing-card">
            <h3><i class="fa fa-cogs w3-margin-right w3-text-theme"></i>Custom Pricing</h3>
            <p class="w3-large">We believe in fair, transparent pricing that scales with your business needs.</p>

            <div class="w3-row-padding w3-margin-top">
              <div class="w3-col m6">
                <h4><i class="fa fa-users w3-margin-right w3-text-theme"></i>Team Size</h4>
                <p>Pricing that adapts to your team size, from small finance teams to enterprise organizations.</p>
              </div>
              <div class="w3-col m6">
                <h4><i class="fa fa-puzzle-piece w3-margin-right w3-text-theme"></i>Solution Fit</h4>
                <p>Customized packages based on your specific FP&A requirements and integration needs.</p>
              </div>
            </div>

            <div class="w3-row-padding w3-margin-top">
              <div class="w3-col m6">
                <h4><i class="fa fa-chart-line w3-margin-right w3-text-theme"></i>ROI Focused</h4>
                <p>Pricing designed to deliver measurable value and quick return on investment.</p>
              </div>
              <div class="w3-col m6">
                <h4><i class="fa fa-handshake w3-margin-right w3-text-theme"></i>Flexible Terms</h4>
                <p>Monthly and annual options with volume discounts and enterprise agreements available.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="w3-col m4">
          <div class="pricing-cta">
            <h3>Get Your Custom Quote</h3>
            <p>Let's discuss your specific needs and find the perfect pricing solution for your organization.</p>

            <div class="w3-margin-top">
              <button class="w3-button w3-theme w3-padding-large w3-round" (click)="requestPricingConsultation()">
                <i class="fa fa-calendar w3-margin-right"></i>Schedule Pricing Call
              </button>
            </div>

            <div class="w3-margin-top">
              <p class="w3-small">No pressure, no obligation - just a conversation about your needs.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Action Bar -->
<div class="action-bar">
  <div class="w3-container">
    <div class="w3-row">
      <div class="w3-col m4">
        <button class="action-button" [class.active]="activeSection === 'demo'" (click)="showSection('demo')">
          <i class="fa fa-play-circle w3-margin-right"></i>Request a Demo
        </button>
      </div>
      <div class="w3-col m4">
        <button class="action-button" [class.active]="activeSection === 'pricing'" (click)="showSection('pricing')">
          <i class="fa fa-dollar-sign w3-margin-right"></i>Schedule a Pricing Call
        </button>
      </div>
      <div class="w3-col m4">
        <button class="action-button" [class.active]="activeSection === 'contact'" (click)="showSection('contact')">
          <i class="fa fa-envelope w3-margin-right"></i>Contact Us
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Demo Request Section -->
<div class="w3-container w3-padding-64 w3-theme-l5" id="demo" [class.section-visible]="activeSection === 'demo'">
  <div class="w3-row">
    <div class="w3-col m6">
      <h3>Ready to See BusinessHub in Action?</h3>
      <p>Schedule a personalized demo to see how our FP&A platform can transform your financial planning and analysis processes.</p>
      <p>During your demo, you'll see:</p>
      <ul class="w3-ul">
        <li><i class="fa fa-play w3-margin-right w3-text-theme"></i>Live platform walkthrough</li>
        <li><i class="fa fa-play w3-margin-right w3-text-theme"></i>Real-world use cases</li>
        <li><i class="fa fa-play w3-margin-right w3-text-theme"></i>Custom implementation options</li>
      </ul>
    </div>
    <div class="w3-col m6">
      <h3>Get in Touch</h3>
      <p>Ready to transform your FP&A processes? Our team is here to help.</p>
      <p><i class="fa fa-map-marker w3-text-theme w3-xlarge"></i> {{'Chicago, IL'}}</p>
      <p><i class="fa fa-phone w3-text-theme w3-xlarge"></i> {{'+1 (708) 220-9276'}}</p>
      <p><i class="fa fa-envelope-o w3-text-theme w3-xlarge"></i> {{'info@businesshubapp.com'}}</p>
      <!-- <form class="w3-container w3-card-4 w3-padding-16 w3-white" #demoForm>
        <div class="w3-section">
          <label><b>Full Name</b></label>
          <input class="w3-input w3-border" type="text" name="Name" required>
        </div>
        <div class="w3-section">
          <label><b>Company</b></label>
          <input class="w3-input w3-border" type="text" name="Company" required>
        </div>
        <div class="w3-section">
          <label><b>Email</b></label>
          <input class="w3-input w3-border" type="email" name="Email" required>
        </div>
        <div class="w3-section">
          <label><b>Phone</b></label>
          <input class="w3-input w3-border" type="tel" name="Phone">
        </div>
        <div class="w3-section">
          <label><b>Preferred Demo Date</b></label>
          <input class="w3-input w3-border" type="date" name="DemoDate">
        </div>
        <div class="w3-section">
          <label><b>Message (Optional)</b></label>
          <textarea class="w3-input w3-border" name="Message" rows="3" placeholder="Tell us about your current FP&A challenges..."></textarea>
        </div>
        <button type="button" class="w3-button w3-right w3-theme w3-padding-large" (click)="onDemoFormSubmit(demoForm)">
          <i class="fa fa-calendar w3-margin-right"></i>Schedule Demo
        </button>
      </form> -->
    </div>
  </div>
</div>

<!-- Pricing Consultation Section -->
<div class="w3-container w3-padding-64 w3-theme-l5" id="pricing-consultation" [class.section-visible]="activeSection === 'pricing'">
  <div class="w3-row">
    <div class="w3-col m6">
      <h3>Get Your Custom Pricing Quote</h3>
      <p>Let's discuss your specific FP&A needs and find the perfect pricing solution for your organization.</p>
      <p>During our pricing consultation, we'll cover:</p>
      <ul class="w3-ul">
        <li><i class="fa fa-users w3-margin-right w3-text-theme"></i>Your team size and requirements</li>
        <li><i class="fa fa-cogs w3-margin-right w3-text-theme"></i>Integration and customization needs</li>
        <li><i class="fa fa-chart-line w3-margin-right w3-text-theme"></i>Timeline expectations</li>
        <li><i class="fa fa-handshake w3-margin-right w3-text-theme"></i>Implementation and support options</li>
      </ul>
    </div>
    <div class="w3-col m6">
      <h3>Get in Touch</h3>
      <p>Ready to transform your FP&A processes? Our team is here to help.</p>
      <p><i class="fa fa-map-marker w3-text-theme w3-xlarge"></i> {{'Chicago, IL'}}</p>
      <p><i class="fa fa-phone w3-text-theme w3-xlarge"></i> {{'+1 (708) 220-9276'}}</p>
      <p><i class="fa fa-envelope-o w3-text-theme w3-xlarge"></i> {{'info@businesshubapp.com'}}</p>
      <!-- <form class="w3-container w3-card-4 w3-padding-16 w3-white" #pricingForm>
        <div class="w3-section">
          <label><b>Full Name</b></label>
          <input class="w3-input w3-border" type="text" name="Name" required>
        </div>
        <div class="w3-section">
          <label><b>Company</b></label>
          <input class="w3-input w3-border" type="text" name="Company" required>
        </div>
        <div class="w3-section">
          <label><b>Email</b></label>
          <input class="w3-input w3-border" type="email" name="Email" required>
        </div>
        <div class="w3-section">
          <label><b>Phone</b></label>
          <input class="w3-input w3-border" type="tel" name="Phone">
        </div>
        <div class="w3-section">
          <label><b>Company Size</b></label>
          <select class="w3-input w3-border" name="CompanySize" required>
            <option value="">Select company size</option>
            <option value="1-10">1-10 employees</option>
            <option value="11-50">11-50 employees</option>
            <option value="51-200">51-200 employees</option>
            <option value="201-1000">201-1000 employees</option>
            <option value="1000+">1000+ employees</option>
          </select>
        </div>
        <div class="w3-section">
          <label><b>Preferred Consultation Date</b></label>
          <input class="w3-input w3-border" type="date" name="ConsultationDate">
        </div>
        <div class="w3-section">
          <label><b>Current FP&A Challenges</b></label>
          <textarea class="w3-input w3-border" name="Challenges" rows="3" placeholder="Tell us about your current FP&A challenges and goals..."></textarea>
        </div>
        <button type="button" class="w3-button w3-right w3-theme w3-padding-large" (click)="onPricingFormSubmit(pricingForm)">
          <i class="fa fa-calendar w3-margin-right"></i>Schedule Pricing Call
        </button>
      </form> -->
    </div>
  </div>
</div>

<!-- Contact Section -->
<div class="w3-container w3-padding-64 w3-theme-l5" id="contact" [class.section-visible]="activeSection === 'contact'">
  <div class="w3-row">
    <div class="w3-col m5">
      <div class="w3-padding-16"><span class="w3-xlarge w3-border-teal w3-bottombar">Contact Us</span></div>
      <h3>Get in Touch</h3>
      <p>Ready to transform your FP&A processes? Our team is here to help.</p>
      <p><i class="fa fa-map-marker w3-text-theme w3-xlarge"></i> {{'Chicago, IL'}}</p>
      <p><i class="fa fa-phone w3-text-theme w3-xlarge"></i> {{'+1 (708) 220-9276'}}</p>
      <p><i class="fa fa-envelope-o w3-text-theme w3-xlarge"></i> {{'info@businesshubapp.com'}}</p>
    </div>
    <!-- <div class="w3-col m7">
      <form class="w3-container w3-card-4 w3-padding-16 w3-white" #contactForm>
        <div class="w3-section">
          <label><b>Name</b></label>
          <input class="w3-input w3-border" type="text" name="Name" required>
        </div>
        <div class="w3-section">
          <label><b>Email</b></label>
          <input class="w3-input w3-border" type="email" name="Email" required>
        </div>
        <div class="w3-section">
          <label><b>Subject</b></label>
          <input class="w3-input w3-border" type="text" name="Subject" required>
        </div>
        <div class="w3-section">
          <label><b>Message</b></label>
          <textarea class="w3-input w3-border" name="Message" rows="4" required></textarea>
        </div>
        <button type="button" class="w3-button w3-right w3-theme w3-padding-large" (click)="onContactFormSubmit(contactForm)">
          <i class="fa fa-paper-plane w3-margin-right"></i>Send Message
        </button>
      </form>
    </div> -->
  </div>
</div>

<!-- Footer -->
<footer class="w3-container w3-padding-32 w3-theme-d1 w3-center">
  <!-- <h4>Follow BusinessHub</h4>
  <a class="w3-button w3-large social-media-button" href="javascript:void(0)" (click)="onSocialMediaClick('LinkedIn')" title="LinkedIn"><i class="fa fa-linkedin"></i></a>
  <a class="w3-button w3-large social-media-button" href="javascript:void(0)" (click)="onSocialMediaClick('Twitter')" title="Twitter"><i class="fa fa-twitter"></i></a>
  <a class="w3-button w3-large social-media-button" href="javascript:void(0)" (click)="onSocialMediaClick('YouTube')" title="YouTube"><i class="fa fa-youtube"></i></a>
  <a class="w3-button w3-large social-media-button" href="javascript:void(0)" (click)="onSocialMediaClick('Blog')" title="Blog"><i class="fa fa-rss"></i></a> -->
  <p>© 2025 BusinessHub. All rights reserved.</p>

  <div class="scroll-to-top">
    <button class="scroll-to-top-button" (click)="scrollToTop()" title="Go To Top">
      <i class="fa fa-chevron-up"></i>
    </button>
  </div>
</footer>

</body>
</html>
